import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Title from "@components/CustomTypography/Title/Title"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React, {useEffect, useState} from "react"

import styles from "./FeaturesNavigationLink.module.scss"
type Props = {
	data: AdvancedSideAssetMainContent
	active: boolean
	id: number
}

const FeaturesNavigationLink = (props: Props) => {
	const [isHovered, setIsHovered] = useState(false)

	const setHovered = (cond: boolean) => {
		setIsHovered(cond)
	}

	const image =
		isHovered || props.active ? props.data.preview : props.data.inside

	useEffect(() => {
		document.documentElement.style.scrollBehavior = "smooth"
		return () => {
			document.documentElement.style.scrollBehavior = "auto"
		}
	}, [])

	return (
		<a
			className={`${styles.featuresLink} ${
				props.active ? styles.active : ""
			}`}
			href={
				props.data.buttons?.[0].link ? props.data.buttons?.[0].link : ""
			}
			id={`${props.id}`}
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
		>
			{image && props.active && (
				<NewResponsiveImage
					containerClassName={styles.image}
					{...image}
				/>
			)}
			<Title
				className={`${styles.featuresTitleLink} ${
					props.active ? styles.active : ""
				}`}
				content={props.data.title}
				size={"S"}
				capitalize
			/>
		</a>
	)
}

export default FeaturesNavigationLink
